import React, { useEffect } from "react";
import { confirmationPopupState } from "../confirmationPopup";
import userDetail from "Stores/userDetail";

const NoPhoneCredits = () => {
  const { phoneEnabled = false } = userDetail?.userFeatureFlag || {};

  useEffect(() => {
    if (!phoneEnabled) {
      confirmationPopupState.setPopupValues({
        content: `Oops! You don’t have access to purchasing phone numbers. Please contact 
          <a href="mailto:support@salesgear.io" target="_blank" rel="noopener noreferrer">
            support@salesgear.io
          </a> to enable it.`,
        actionBtnText: "Okay",
        needCancelBtn: false,
        callback: () => {
          confirmationPopupState.setShowPopup(false);
        }
      });
    } else {
      confirmationPopupState.setPopupValues({
        content: `Oops! Insufficient credits to purchase phone numbers. Please contact 
          <a href="mailto:support@salesgear.io" target="_blank" rel="noopener noreferrer">
            support@salesgear.io
          </a> to add more credits.`,
        actionBtnText: "Okay",
        needCancelBtn: false,
        callback: () => {
          confirmationPopupState.setShowPopup(false);
        }
      });
    }

    confirmationPopupState.setShowPopup(true);
  }, [phoneEnabled]);

  return null;
};

export default NoPhoneCredits;